import molin_17 from '../../assets/images/tra/molin_17.webp';
import molin_18 from '../../assets/images/tra/molin_18.webp';
import molin_19 from '../../assets/images/tra/molin_19.webp';
import MolinHeader from '../../components/MolinHeader';
import { useState } from 'react';
import '../../styles/common.css'
export default function Merchant() {
    const [storyStatus, setStoryStatus] = useState(0);
    return (
        <div className="relative">
            <MolinHeader></MolinHeader>

            {storyStatus === 0 && (
                <div>
                    <img src={molin_17} alt="Hero background" className="w-full h-auto" />
                    <div className="top-[45%] left-[51%] absolute">
                        <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
                            onClick={() => setStoryStatus(1)}>
                        </button>
                    </div>
                    <div className='absolute bottom-[25%] left-[40%] h-[6vw] w-[10vw] transition-transform duration-300 hover:scale-110'>
                        <div className="flex flex-col text-center font-bold">
                            <span className="text-[#000000] text-[1vw]">项元汴</span>
                            <span className="text-[#000000] text-[0.8vw]">Xiang Yuanbian</span>
                        </div>
                    </div>
                    <div className='absolute bottom-[20%] left-[50%] h-[6vw] w-[10vw] transition-transform duration-300 hover:scale-110'>
                        <div className="flex flex-col text-center font-bold">
                            <span className="text-[#000000] text-[1vw]">郭五游</span>
                            <span className="text-[#000000] text-[0.8vw]">Guo Wuyou</span>
                        </div>
                    </div>
                </div>
            )}
            {storyStatus === 1 && (
                <div>
                    <img src={molin_18} alt="Hero background" className="w-full h-auto" />
                    <div className="top-[30%] left-[66%] absolute">
                        <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
                            onClick={() => setStoryStatus(2)}>
                        </button>
                    </div>
                    <div className='absolute bottom-[18%] left-[58%] h-[6vw] w-[10vw] transition-transform duration-300 hover:scale-110'>
                        <div className="flex flex-col text-center font-bold">
                            <span className="text-[#000000] text-[1vw]">郭五游</span>
                            <span className="text-[#000000] text-[0.8vw]">Guo Wuyou</span>
                        </div>
                    </div>
                    <div className={`chat-bubble-base absolute bottom-[35%] left-[98%] transform -translate-x-1/2 chat-bubble-left 
                    chat-bubble-fade-in ${storyStatus >= 1 ? 'chat-bubble-fade-in-active' : ''}`}>
                        <span className='mt-[1vw] typing-effect'>“项先生常从我这里购买奇珍古董”</span>
                        <span className='mb-[1vw] typing-effect'>"Master Xiang frequently purchases rare and precious antiques from me."</span>
                    </div>
                    <div className="top-[52%] absolute left-[38%] w-[26%] z-[9999] text-left">
                        <div className="flex flex-col">
                            <span className="text-[#000000] text-[2.1vw]">售卖</span>
                            <span className="text-[#000000] text-[2.1vw] mt-[-0.8vw]">古董</span>
                            <span className="text-[#000000] text-[1vw] ml-[-0.2vw] mt-[-0.2vw]">Sell Antiques</span>
                        </div>
                    </div>
                    <div className="top-[37.5%] absolute left-[44%] w-[22%] z-[9999] text-justify">
                        <div className="flex flex-col">
                            <span className="text-[#000000] text-[0.9vw] mt-[5.4vw] leading-[1.1vw]">在项元汴的藏品中其中有在本地收购外地商人兜售的古董，比如郭五游和王复元便是与项元汴做交易的两个代表性商人。例如：陈继儒《妮古录》载：“子昂亭林碑，其真迹曾粘村民屋壁，王野宾买之以售项氏。</span>
                        </div>
                    </div>
                    <div className="top-[54%] absolute left-[44%] w-[18%] z-[9999] text-justify">
                        <div className="flex flex-col">
                            <span className="text-[#000000] text-[0.7vw] mt-[1.6vw] leading-[1.1vw]">Within Xiang Yuanbian’s collection were antiques acquired locally from itinerant merchants from other regions, such as Guo Wuyou and Wang Fuyuan, who were representative antique dealers engaged in transactions with Xiang. For example, Chen Jiru’s Nigu Lu records: “The Zitang Tinglin Stele’s genuine inscription was once pasted on a peasant’s wall. Wang Yabin purchased it and sold it to the Xiang family.”</span>
                        </div>
                    </div>
                </div>
            )}
            {storyStatus === 2 && (
                <div className="top-[30%] left-[66%] absolute">
                    <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
                        onClick={() => setStoryStatus(3)}>
                    </button>
                </div>
            )}
            {storyStatus >= 2 && (
                <div>
                    <img src={molin_19} alt="Hero background" className="w-full h-auto" />
                    <div className='absolute bottom-[25%] left-[36%] h-[6vw] w-[10vw] transition-transform duration-300 hover:scale-110'>
                        <div className="flex flex-col text-center font-bold">
                            <span className="text-[#000000] text-[1vw]">项元汴</span>
                            <span className="text-[#000000] text-[0.8vw]">Xiang Yuanbian</span>
                        </div>
                    </div>
                    <div className='absolute bottom-[18%] left-[75%] h-[6vw] w-[10vw] transition-transform duration-300 hover:scale-110'>
                        <div className="flex flex-col text-center font-bold">
                            <span className="text-[#000000] text-[1vw]">郭五游</span>
                            <span className="text-[#000000] text-[0.8vw]">Guo Wuyou</span>
                        </div>
                    </div>
                    <div className={`chat-bubble-base absolute top-[35%] left-[45%] transform -translate-x-1/2 chat-bubble-right 
                    chat-bubble-fade-in ${storyStatus >= 2 ? 'chat-bubble-fade-in-active' : ''}`}>
                        <span className='mt-[1vw] typing-effect'>“郭兄可曾听说新奇外形的瓷器。其形酷似莲花。”</span>
                        <span className='mb-[1vw] typing-effect'>"Brother Guo, have you heard of ceramics with an unusual shape? Its form resembles a lotus."</span>
                    </div>
                </div>
            )}
            {storyStatus === 3 && (
                <div>
                    <div className={`chat-bubble-base absolute bottom-[35%] left-[98%] transform -translate-x-1/2 chat-bubble-left
                    chat-bubble-fade-in ${storyStatus >= 2 ? 'chat-bubble-fade-in-active' : ''}`}>
                        <span className='mt-[1vw] typing-effect'>“略有耳闻，我可为项先生一寻。”</span>
                        <span className='mb-[1vw] typing-effect'>"I’ve heard of it in passing. I can go search for it for Master Xiang."</span>
                    </div>
                </div>
            )}
        </div>
    )
}